import MUIBreadcrumbs, { BreadcrumbsProps as MUIBreadcrumbsProps } from "@material-ui/core/Breadcrumbs";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";

type Breadcrump = {
  label: string;
  link: string;
  active: boolean;
};

type BreadcrumpsProps = {
  breadcrumps: Breadcrump[];
};

const Breadcrumps: FC<MUIBreadcrumbsProps & BreadcrumpsProps> = ({ breadcrumps, ...rest }) => {
  return (
    <MUIBreadcrumbs aria-label="breadcrumb" {...rest}>
      {breadcrumps.map((breadcrump) =>
        breadcrump.active ? (
          <Typography key={breadcrump.label} color="textPrimary">
            {breadcrump.label}
          </Typography>
        ) : (
          <Link key={breadcrump.label} to={breadcrump.link}>
            {breadcrump.label}
          </Link>
        ),
      )}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumps;
